<div class="w-full h-full">
  <div class="supplier-card-row">
    <div class="left-side">Supplier Name</div>
    <div class="text-right">{{ deploySupplierContext.supplierName }}</div>
  </div>
  <div class="supplier-card-row">
    <div class="left-side">Required Tags</div>
    <div class="text-right">
      <span
        *ngFor="let tag of deploySupplierContext.tagMatches"
        class="tag-item"
        [class.fulfilled]="tag.fulfilled"
      >
        {{ tag.name }}
      </span>
      <span *ngIf="deploySupplierContext.tagMatches.length === 0">None</span>
    </div>
  </div>
</div>
